<template>
  <div class="page-culproduct">
    <div class="empty" v-if="!goods_list.length">暂无订单...</div>
    <div
      v-for="goods in goods_list"
      :key="goods.order_no"
      class="page-culproduct_goodsList"
    >
      <div class="page-culproduct_orderNum">
        <van-icon name="orders-o" />
        <span>{{ goods.order_no }}</span>
        <span class="price f-r">￥{{ goods.total_price }}</span>
      </div>
      <van-card
        :num="t.buy_number"
        :price="t.price"
        :title="t.title"
        :thumb="t.image"
        v-for="(t, index) in goods.item"
        :key="index"
      />
      <div class="footer">
        <span class="status f-r"
          >订单状态: <span class="red">{{ goods.order_status }}</span></span
        >
      </div>
    </div>
  </div>
</template>

<script>
import { getCulProductUrl } from "@js/shoppingUrl.js";
import md5 from "js-md5";
import axios from "axios";
import { Card, Icon } from "vant";
export default {
  name: "culproduct",
  data() {
    return {
      client_id: "bb89496b4c97801a7367420c14b2208f",
      secret: "asdfdfdfasdfwerfgh4545d",
      timestamp: new Date().getTime(),
      goods_list: [],
    };
  },
  mounted() {
    this.getProduct();
  },
  computed: {
    $sign() {
      return md5(this.$params + "asdfdfdfasdfwerfgh4545d");
    },
    $params() {
      return `client_id=${this.client_id}&timestamp=${this.timestamp}`;
    },
    // 用户手机号
    userPhone() {
      return this.$store.state.userInfo.info.phone;
    },
  },
  methods: {
    async getProduct() {
      // 首次登陆无手机号 限制发送请求
      if (this.userPhone == "") {
        return this.$toast("请先绑定手机号！");
      }
      await axios
        .get(getCulProductUrl, {
          params: {
            client_id: this.client_id,
            timestamp: this.timestamp,
            sign: this.$sign,
            mobile: this.userPhone,
          },
        })
        .then(({ data: { data } }) => {
          this.goods_list = data;
        });
    },
  },
  components: {
    [Card.name]: Card,
    [Icon.name]: Icon,
  },
};
</script>

<style lang="less" scoped>
.page-culproduct {
  .empty {
    margin: 40px auto;
    text-align: center;
    font-size: 14px;
    color: #aaa;
  }
  .page-culproduct_goodsList {
    margin-bottom: 20px;
    .page-culproduct_orderNum {
      background-color: #eaf8ff;
      font-size: 14px;
      font-family: Verdana, Tahoma, arial;
      line-height: 40px;
      height: 40px;
      margin-bottom: -8px;
      overflow: hidden;
      .van-icon {
        margin: 0 6px;
        vertical-align: middle;
      }

      .price {
        color: #d2364c;
      }
    }
    /deep/.van-card {
      .van-card__price {
        color: #d2364c;
      }
    }
    .footer {
      height: 40px;
      line-height: 40px;
      background-color: #fafafa;
      font-size: 14px;
      padding-right: 8px;
      .status {
      }
    }
  }
  .f-r {
    float: right;
  }
  .red {
    color: rgb(94, 91, 91);
  }
}
</style>